import { Component, OnInit, Input, NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  @Input('errors') errors;
  constructor() { }

  ngOnInit() {
  }

}
